module.exports = __webpack_public_path__ + "img/vizio1-cover-1.ec96bed7.jpg";